import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.js';
import Dashboard from './pages/Dashboard.js';
import Accounts from './pages/Accounts.js';
import Parties from './pages/Parties.js';
import Journal from './pages/Journal.js';
import ImportPage from './pages/ImportPage.js';
import WechatConfirm from './pages/WechatConfirm.js';
import SignalCenter from './pages/SignalCenter.js';
import Reports from './pages/Reports.js';
import Closing from './pages/Closing.js';
import AdminTenants from './pages/AdminTenants.js';
import Members from './pages/Members.js';
import Login from './pages/Login.js';

function App() {
  return (
    <Routes>
      {/* 登录页（试点期匿名可访问业务页，登录后获得租户隔离与个性化体验） */}
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="accounts" element={<Accounts />} />
        <Route path="parties" element={<Parties />} />
        <Route path="journal" element={<Journal />} />
        <Route path="import" element={<ImportPage />} />
        <Route path="wechat" element={<WechatConfirm />} />
        <Route path="monitor" element={<SignalCenter />} />
        <Route path="reports" element={<Reports />} />
        <Route path="closing" element={<Closing />} />
        <Route path="team" element={<Members />} />
        <Route path="admin" element={<AdminTenants />} />
      </Route>
    </Routes>
  );
}

export default App;
